/**
 * Standardized filter field for report cards.
 */
export default function ReportFilterField({ id, label, children, className = "" }) {
  return (
    <div className={`rpt-field ${className}`.trim()}>
      {label && (
        <label htmlFor={id} className="rpt-field__label">
          {label}
        </label>
      )}
      {children}
    </div>
  );
}
